<template lang="pug">
figure.image.logo(:class="size")
  img(
    :src="logo || require('@/assets/icons/logo.svg')"
    alt="Program Logo"
    @error="programLogoOnError"
  )
</template>

<script>
export default {
  name: "WtProgramLogo",

  props: {
    logo: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "is-96x96",
      validator(size) {
        return (
          ["is-128x128", "is-96x96", "is-64x64", "is-48x48"].indexOf(size) !==
          -1
        );
      }
    }
  },

  methods: {
    programLogoOnError(event) {
      event.target.onerror = null;
      event.target.src = require("@/assets/icons/logo.svg");
    }
  }
};
</script>

<style lang="sass" scoped>
.image
  overflow: hidden
.logo
  margin: 0 auto
</style>
